import React from "react";
import "../component/productCategoryTable.css";

const ProductCategoryTable = ({
  productCategory,
  onEditProductCategoryClicked,
  onDeleteProductCategoryClicked,
}) => {
  const editProductCategory = (productCategory) => {
    onEditProductCategoryClicked(productCategory);
  };

  const deleteProductCategory = (productCategory) => {
    onDeleteProductCategoryClicked(productCategory);
  };

  return (
    <div className="product-category-table-container">
      <table className="product-category-table">
        <thead>
          <tr>
            <th width="100px">No</th>
            <th>Nama Kategori Produk</th>
            <th width="150px">Actions</th>
          </tr>
        </thead>
        <tbody>
        {productCategory.length > 0 ? (
            productCategory.map((category, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{category.product_category_name}</td>
                <td>
                  <button
                    className="edit-doctor-specialist-button"
                    onClick={() => {
                      editProductCategory(category);
                    }}
                  >
                    Edit
                  </button>
                  <button
                    className="delete-doctor-specialist-button"
                    onClick={() => {
                      deleteProductCategory(category);
                    }}
                  >
                    Hapus
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" style={{ textAlign: "center" }}>
                Data tidak tersedia
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ProductCategoryTable;
